import { Roles } from 'roles';
import _ from 'lodash';
import moment from 'moment';

import { Meteor } from 'meteor/meteor';

import { Flights } from '../../flights/flights';
import { Montgolfieres } from '../../montgolfieres/montgolfieres';

export const pilot = new Roles.Role('pilot');

/*
 *	List Permissions
 *	Manage page access
 */
pilot.allow('alerts.list', true);
pilot.allow('calendar.list', true);
pilot.allow('orders.list', true);
pilot.allow('flights.list', true);
pilot.allow('flights-type.list', true);
pilot.allow('places.list', true);
pilot.allow('prices.list', true);
pilot.allow('promotions.list', true);
pilot.allow('options.list', false);
pilot.allow('users.list', true);
pilot.allow('montgolfieres.list', true);
pilot.allow('statistics.list', false);
pilot.allow('my-flights.list', true);

/*
 *	Users
 */
pilot.allow('users.update', (userId, doc, fields) => {
	return doc._id === userId;
});
pilot.deny('users.update', (userId, doc, fields, modifier) => {
	if (Roles.userHasRole(userId, 'god') || Roles.userHasRole(userId, 'organizer'))
		return false;

	return _.includes(fields, 'roles')
			 || (modifier &&
					 modifier['$set'] &&
						 modifier['$set']['roles'] &&
							 (modifier['$set']['roles'].length > 1 || modifier['$set']['roles'][0] !== "pilot"));
});

/*
 *	Montgolfieres
 */
pilot.allow('montgolfieres.insert', false);
pilot.allow('montgolfieres.update', false);
pilot.allow('montgolfieres.remove', false);

/*
 *  Flights
 */
pilot.allow('flights.insert', (userId, doc) => {
	/*if (moment().startOf('day').isAfter(moment(doc.date).startOf('day')))
		return false;

	if (Flights.findOne({ date: doc.date, period: doc.period, pilotId: userId }))
		return false;

	const montgolfiere = Montgolfieres.findOne(doc.montgolfiereId);
	if ((doc.montgolfiereId && !montgolfiere) || (montgolfiere && !_.includes(montgolfiere.allowedPilots, userId)))
		return false;

	if (doc.reservationIds && doc.reservationIds.length)
		return false;

	if (doc.pilotId !== userId)
		return false;

	if (doc.status !== "preparing")
		return false;

	const projection = {
		$elemMatch: {
			startDate: {$lte: doc.date},
			endDate: {$gte: doc.date},
			isAvailable: true,
			period: doc.period
		}
	};

	if (!Meteor.users.findOne({"_id": userId, "profile.availabilities": projection}))
		return false;*/

	return true;
});
pilot.allow('flights.update', false);
pilot.allow('flights.prepare', (userId, doc) => {
	return doc.pilotId === userId && doc.status == "preparing";
});
pilot.allow('flights.enclose', (userId, doc) => {
	return doc.status == "prepared"
		&& doc.pilotId == userId
		/*&& moment().isAfter(moment(doc.date).startOf('day').add(doc.period == 'morning' ? 12 : 23, 'hours'))*/;
});
pilot.allow('flights.remove', (userId, doc) => {
	return doc.status === 'preparing' && doc.pilotId === userId;
});

/*
 *  Lieux d'envols
 */
pilot.allow('places.insert', false);
pilot.allow('places.update', false);
pilot.allow('places.remove', false);

/*
 *  Reservations
 */
pilot.allow('reservations.insert', true);
pilot.allow('reservations.update', true);
pilot.allow('reservations.remove', true);

/*
 *  Alerts
 */
pilot.allow('alerts.insert', true);
pilot.allow('alerts.update', true);
pilot.allow('alerts.remove', true);



/** WEBPACK FOOTER **
 ** ./src/universal/collections/users/roles/pilot.js
 **/